export default __webpack_public_path__ + "static/media/Seal of Deepest Tartaros.fcb013ec.jpg";